<template>
  <div>
    <div class="dialogContainer">
      <el-form
        ref="handleForm"
        :model="handleForm"
        :rules="handleRules"
        label-position="right"
        label-width="150px"
        hide-required-asterisk
      >
        <el-form-item label="超管账号(手机号)" prop="mobile">
          <el-input
            v-model.number="handleForm.mobile"
            :rows="6"
            placeholder="请输入超管账号(手机号)"
            class="handle-form-input"
            maxlength="11"
            show-word-limit
          />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="closeDialog">
        取消
      </el-button>
      <el-button
        :loading="ajaxLoading"
        type="primary"
        size="medium"
        @click="handleAddSubject"
      >
        {{ ajaxLoading ? "Loading" : "确定" }}
      </el-button>
    </div>
  </div>
</template>

<script>
// 获取API
import { demandsensitivewordsCheck } from '@/api/systemManage/sensitiveManage';
// 获取API
import {
  whiteListAdd
} from '@/api/productOperation/mrDesk/whiteList';
import { mapGetters } from 'vuex';

export default {
  name: 'DialogInfo',
  props: {
    type: {
      type: String,
      default: null
    },
    dataList: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    return {
      ajaxLoading: false,
      // 操作表单
      handleForm: {
        id: '',
        mobile: ''
      },
      handleRules: {
        mobile: [
          { required: true, message: '超管账号不能为空', trigger: 'blur' },
          { pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/, message: '请输入正确的超管账号', trigger: ['blur', 'change'] }
        ]
      }
    };
  },
  watch: {
    dataList: {
      handler(val) {
        if (val) {
          if (this.type === 'edit') {
            this.handleForm = val;
          }
        }
      }
    }
  },
  mounted() {
    if (this.type === 'edit') {
      this.handleForm = this.dataList;
    }
  },
  methods: {
    // 新增
    handleAddSubject() {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          var mobile = {
            mobile: this.handleForm.mobile
          };
          demandsensitivewordsCheck(mobile).then((response) => {
            if (response.data && response.data.isChoose) {
              this.$message({
                type: 'warning',
                message: response.data.badword
              });
              return;
            } else {
              this.ajaxLoading = true;
              if (this.type === 'add') {
                // 添加
                const option = {
                  mobile: this.handleForm.mobile,
                  createUserCode: this.userInfo.code
                };
                whiteListAdd(option)
                  .then((res) => {
                    this.$emit('closeDialog');
                    this.ajaxLoading = false;
                  })
                  .catch((err) => {
                    this.ajaxLoading = false;
                    console.log(err);
                  });
              } else {
                // 编辑
                // const option1 = {
                //   id: this.handleForm.id,
                //   content: this.handleForm.content,
                //   updateUserCode: this.userInfo.code
                // };
                // deskPromptUp(option1)
                //   .then((res) => {
                //     this.$emit('closeDialog');
                //     this.ajaxLoading = false;
                //   })
                //   .catch((err) => {
                //     this.ajaxLoading = false;
                //     console.log(err);
                //   });
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 关闭
    closeDialog() {
      this.$emit('closeDialog');
    }
  }
};
</script>
<style lang="scss" scoped>
.upload-picture {
  float: right;
}
.handle-form-input {
  width: 96%;
}
.picture-wrapper {
  width: 96%;
  height: 100px;
  margin-top: 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
.dialog-footer {
  text-align: right;
  padding-top: 20px;
}
</style>
